"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeDefault = void 0;
exports.themeDefault = {
    primary: '#ffc800',
    secondary: '#8d02d8',
    success: '#5cb85c',
    info: '#1380e0',
    warning: '#ff9d06',
    danger: '#fa004c',
    light: '#e3e3e3',
    dark: '#222',
};
//# sourceMappingURL=ITheme.js.map